import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProModalSessionService {
  private hasConsumedProModalForThisAppLoad = signal(false)

  consumeProModalShowForSession(): boolean {
    if (this.hasConsumedProModalForThisAppLoad()) {
      return false;
    }
    this.hasConsumedProModalForThisAppLoad.set(true);
    return true;
  }
}
